import React, { useRef } from "react";
import "../tree-view/TreeViewItemExpandableOption.js";
import { TreeView } from "../tree-view/TreeView.js";
import { TreeViewItemSelectOption } from "../tree-view/TreeViewItemSelectOption.js";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
import { AutocompleteInfoMessage } from "./AutocompleteInfoMessage.js";
import { AutocompletePlaceholder } from "./AutocompletePlaceholder.js";
import { FormAutocompleteInput } from "./FormAutocompleteInput.js";
import { useAutocompleteState } from "./hooks.js";
const InlineAutocomplete = ({
  value,
  defaultOption,
  options,
  placeholder,
  emptyPlaceholder,
  subInfoMessage,
  errorMessage,
  onValueChange,
  onFilterChange,
  errorMessageOrientation,
  dataTestId,
  allowEmptyValue,
  mode = "server"
}) => {
  if (mode === "client") {
    throw new Error("Mode not implemented.");
  }
  const { classes: styles } = useAutocompleteClasses();
  const autocompleteRef = useRef(null);
  const { open, inputValue, autocompleteState, handleInputChange, handleBlur, handleKeyDown, handleClear, handleAutocompleteChange } = useAutocompleteState({
    value,
    defaultOption,
    options,
    onValueChange,
    onFilterChange,
    allowFreeInputValue: false,
    allowEmptyValue,
    multiple: false,
    isAlwaysOpen: true
  });
  return /* @__PURE__ */ React.createElement("div", { className: styles.autocompleteContainer, "data-testid": dataTestId, ref: autocompleteRef }, /* @__PURE__ */ React.createElement(
    FormAutocompleteInput,
    {
      value: inputValue,
      onInputChange: handleInputChange,
      onBlur: handleBlur,
      clear: handleClear,
      placeholder,
      onKeyDown: handleKeyDown
    }
  ), !inputValue && !options?.length ? /* @__PURE__ */ React.createElement(AutocompletePlaceholder, { emptyPlaceholder }) : /* @__PURE__ */ React.createElement(TreeView, { className: styles.autocompleteViewList }, options?.map((option) => /* @__PURE__ */ React.createElement(
    TreeViewItemSelectOption,
    {
      selected: option.value === value,
      key: option.value,
      itemId: option.value,
      label: option.label,
      onClick: (value2) => handleAutocompleteChange(null, value2)
    }
  ))), /* @__PURE__ */ React.createElement(
    AutocompleteInfoMessage,
    {
      subInfoMessage,
      autocompleteState,
      hideMessage: open,
      containerRef: autocompleteRef,
      dataTestId: "autocompleteInlineErrorMessage",
      message: errorMessage,
      messageOrientation: errorMessageOrientation
    }
  ));
};
export {
  InlineAutocomplete
};
//# sourceMappingURL=InlineAutocomplete.js.map
